import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';
import {t} from 'shared/core';

const TimeOffTime = observer(({timeOff}) => {
  if (timeOff.allDay) return <FormattedMessage id='time_tracking.shifts.All day'/>;

  const timeFormat = t('components.dates.TIMESTAMP_FORMAT');

  return (
    <FormattedMessage
      id='components.dates.DATE_SPAN'
      values={{startDate: timeOff.startsAt.format(timeFormat), endDate: timeOff.endsAt.format(timeFormat)}}
    />
  );
});

const TimeOffCard = observer(({timeOff, continuesBefore, continuesAfter}) => {
  const classNames = _.compact([
    'TimeOffCard',
    continuesBefore && 'TimeOffCard--continuesBefore',
    continuesAfter && 'TimeOffCard--continuesAfter'
  ]);

  return (
    <div className={classNames.join(' ')}>
      <span className='medium'><TimeOffTime timeOff={timeOff}/></span>
      {timeOff.typeName && <span className='TimeOffCard-type'>{timeOff.typeName}</span>}
    </div>
  );
});

export default TimeOffCard;
